<template>
  <div class="khlr-container">
    <el-row>
      <el-col class="tcf-row">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              客户录入
            </div>
            <div class="card-content" >
              <el-form :model="eForm" :rules="eRules" ref="eForm" label-width="100px">
                <el-form-item label="姓名" prop="realname">
                  <el-input v-model="eForm.realname" maxlength="5"></el-input>
                </el-form-item>
                <el-form-item label="电话" prop="tel">
                  <el-input v-model="eForm.tel" maxlength="11" minlength="11"></el-input>
                </el-form-item>
                <el-form-item label="微信" prop="weixin">
                  <el-input v-model="eForm.weixin" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                  <el-radio-group v-model="eForm.sex">
                    <el-radio label="2">未知</el-radio>
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="地区" prop="city">
                  <el-cascader
                    style="width:100%"
                    v-model="eForm.city"
                    :options="cityoptions"
                    filterable></el-cascader>
                </el-form-item>
                <el-form-item label="线下门店" prop="shop">
                  <el-input v-model="eForm.shop" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="门店面积" prop="area" style="width: 400px;">
                  <el-input v-model="eForm.area">
                    <template slot="append">m²</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="分组" prop="groupid">
                  <el-select v-model="eForm.groupid" filterable :clearable="true">
                    <el-option
                      v-for="gitem in groupoptions"
                      :key="gitem.value"
                      :label="gitem.label"
                      :value="gitem.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="标签" prop="labels">
                  <el-checkbox-group v-model="eForm.labels" :max="3">
                    <el-checkbox v-for="titem in tagaoption" :label="titem.tagid" name="labels">{{titem.name}}</el-checkbox>
                  </el-checkbox-group>
                  <el-button size="small" icon="el-icon-edit" type="text" @click="tagsDrawer = true">标签管理...</el-button>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input type="textarea" v-model="eForm.remark" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="loading" @click="submitForm('eForm')">立即提交</el-button>
                  <el-button @click="resetForm('eForm')">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-drawer
      title="标签管理"
      :visible.sync="tagsDrawer"
      direction="rtl">
      <div class="tags-container">
        <el-row>
          <div v-for="t in tagaoption" class="tags-item">
            <span>{{t.name}}</span>
            <el-button v-if="t.userid != 0" type="danger" @click="delTags(t.tagid)" class="tags-del" icon="el-icon-close" circle></el-button>
          </div>
          <el-button @click="addTags" size="small" icon="el-icon-plus" type="primary" plain>添加</el-button>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { validatePhoneNumber } from '@/utils/validate'
import { getCity } from '@/utils/city'
import { getClientGroupList, getClientLabel, editClientLabel, addClient } from '@/api/work'

export default {
  name: 'khlr',
  computed: {
    user: getUser
  },
  data() {
    const validateTel = (rule, value, callback) => {
      if (!validatePhoneNumber(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      tagsDrawer: false,
      cityoptions: getCity(),
      groupoptions: [],
      tagaoption: [],
      loading: false,
      eForm: {
        realname: '',
        tel: '',
        weixin: '',
        city: [],
        remark: '',
        groupid: null,
        labels: [],
        clientid: 0,
        sex: null,
        shop: '',
        area: null
      },
      eRules: {
        realname: [{ required: true, message: '请输入客户真实姓名', trigger: 'blur' }],
        tel: [{ required: true, trigger: 'blur', validator: validateTel }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        city: [{ type: 'array', required: true, message: '请选择客户所在地区', trigger: 'blur' }],
        area: [
          {
            pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
            message: '请输入正确的面积！',
            trigger: 'blur',
            required: false
          }
        ]
      }
    }
  },
  created() {
    getClientGroupList({ userid: this.user.dUserid }).then(response => {
      let group = []
      for (let g of response.data) {
        if (g.groupid > 3) {
          group.push({ value: g.groupid, label: g.name })
        }
      }
      this.groupoptions = group
    }).catch(() => {})
    this.getClientLabel()
  },
  methods: {
    getClientLabel() {
      getClientLabel({ userid: this.user.dUserid }).then(response => {
        this.tagaoption = response.data
      }).catch(() => {})
    },
    addTags() {
      this.$prompt('请输入标签名称', '添加标签', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '标签名称不可为空'
      }).then(({ value }) => {
        editClientLabel({ userid: this.user.dUserid, type: 0, content: value }).then(response => {
          this.getClientLabel()
        }).catch(() => {})
      }).catch(() => {})
    },
    delTags(tagid) {
      this.$confirm('此操作将永久删除此标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        editClientLabel({ type: 2, tagid: tagid }).then(response => {
          this.eForm.labels = []
          this.getClientLabel()
        }).catch(() => {})
      }).catch(() => {})
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.loading) {
            this.loading = true
            const data = {
              userid: this.user.dUserid,
              realname: this.eForm.realname,
              tel: this.eForm.tel,
              weixin: this.eForm.weixin,
              province: this.eForm.city[0],
              city: this.eForm.city[1],
              county: this.eForm.city[2],
              remark: this.eForm.remark,
              groupid: this.eForm.groupid,
              labels: this.eForm.labels.join(','),
              clientid: 0,
              sex: this.eForm.sex,
              shop: this.eForm.shop,
              area: this.eForm.area
            }
            addClient(data).then(response => {
              this.$message({
                message: '客户录入成功',
                type: 'success'
              })
              this.resetForm(formName)
              this.eForm.area = null
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }

}
</script>

<style lang="scss" scoped>
.khlr-container {
  .tags-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .tags-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .tags-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
}
</style>
